/**
 * Departments Components Index
 * Re-exports all department components
 */

export { DeleteConfirmModal } from './DeleteConfirmModal';
export { DepartmentFormModal } from './DepartmentFormModal';
export { DepartmentsPage } from './DepartmentsPage';
